import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import TypingAnimation from './components/TypingAnimation';
import AnnouncementTicker from './components/AnnouncementTicker';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppFAB from './components/WhatsAppFAB';

import HomePage from './pages/HomePage';
import CollectionsPage from './pages/CollectionsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SearchPage from './pages/SearchPage';
import CartPage from './pages/CartPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogsPage from './pages/BlogsPage';
import BlogDetailPage from './pages/BlogDetailPage';

import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminProductsPage from './pages/AdminProductsPage';
import AdminCategoriesPage from './pages/AdminCategoriesPage';
import AdminBlogsPage from './pages/AdminBlogsPage';
import AdminCustomersPage from './pages/AdminCustomersPage';
import AdminCRMPage from './pages/AdminCRMPage';
import AdminStatisticsPage from './pages/AdminStatisticsPage';
import AdminSmartDashboardPage from './pages/AdminSmartDashboardPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminContentPage from './pages/AdminContentPage';
import ScrollToTop from './components/ScrollToTop';

const PublicLayout = ({ children }) => (
  <>
    <TypingAnimation />
    <AnnouncementTicker />
    <Navigation />
    <main>{children}</main>
    <Footer />
    <WhatsAppFAB />
    <Toaster position="top-right" richColors />
  </>
);

const AdminLayout = ({ children }) => (
  <>
    <main>{children}</main>
    <Toaster position="top-right" richColors />
  </>
);

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/collections" element={<PublicLayout><CollectionsPage /></PublicLayout>} />
        <Route path="/collections/:category" element={<PublicLayout><CollectionsPage /></PublicLayout>} />
        <Route path="/collections/:category/:subcategory" element={<PublicLayout><CollectionsPage /></PublicLayout>} />
        <Route path="/product/:sku" element={<PublicLayout><ProductDetailPage /></PublicLayout>} />
        <Route path="/search" element={<PublicLayout><SearchPage /></PublicLayout>} />
        <Route path="/cart" element={<PublicLayout><CartPage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/blogs" element={<PublicLayout><BlogsPage /></PublicLayout>} />
        <Route path="/blogs/:slug" element={<PublicLayout><BlogDetailPage /></PublicLayout>} />

        <Route path="/admin/login" element={<AdminLayout><AdminLoginPage /></AdminLayout>} />
        <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        <Route path="/admin/products" element={<AdminLayout><AdminProductsPage /></AdminLayout>} />
        <Route path="/admin/products/new" element={<AdminLayout><AdminProductsPage /></AdminLayout>} />
        <Route path="/admin/categories" element={<AdminLayout><AdminCategoriesPage /></AdminLayout>} />
        <Route path="/admin/blogs" element={<AdminLayout><AdminBlogsPage /></AdminLayout>} />
        <Route path="/admin/blogs/new" element={<AdminLayout><AdminBlogsPage /></AdminLayout>} />
        <Route path="/admin/customers" element={<AdminLayout><AdminCustomersPage /></AdminLayout>} />
        <Route path="/admin/customers/new" element={<AdminLayout><AdminCustomersPage /></AdminLayout>} />
        <Route path="/admin/crm" element={<AdminLayout><AdminCRMPage /></AdminLayout>} />
        <Route path="/admin/statistics" element={<AdminLayout><AdminStatisticsPage /></AdminLayout>} />
        <Route path="/admin/smart-dashboard" element={<AdminLayout><AdminSmartDashboardPage /></AdminLayout>} />
        <Route path="/admin/content" element={<AdminLayout><AdminContentPage /></AdminLayout>} />
        <Route path="/admin/settings" element={<AdminLayout><AdminSettingsPage /></AdminLayout>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
